export function error(err, customAttributes = {}, notifyNR = true) {
	if (notifyNR) {
		const newrelic = window.newrelic || window.NREUM;
		const userId = window?.ui?.getCookie('LAU');

		const outgoingError = typeof err === 'string' ? new Error(err) : err;
		newrelic?.noticeError?.(outgoingError, { sourceApp: 'hintsui-eval', level: 'error', userId, ...customAttributes });
	}

	console.error(err); // eslint-disable-line no-console
}

// Note: Info & Warn logs needs to be enabled for each page level under Browser > Application settings > Collect logs manually > Select 'Info'
export function warn(message, customAttributes = {}) {
	const userId = window?.ui?.getCookie('LAU');
	const newrelic = window.newrelic || window.NREUM;
	const attrs = { sourceApp: 'hintsui-eval', userId, ...customAttributes };
	newrelic?.log(message, { level: 'warn', customAttributes: attrs });
}

export function info(message, customAttributes = {}) {
	const userId = window?.ui?.getCookie('LAU');
	const newrelic = window.newrelic || window.NREUM;
	const attrs = { sourceApp: 'hintsui-eval', userId, ...customAttributes };
	newrelic?.log(message, { level: 'info', customAttributes: attrs });
}

export default { error, warn, info };
